const Tools = {
  methods: {
    assetsPath(path) {
      const imageCDN = this.$config.public.assetsPublicPath
      const isNotDevEnv =
        this.$config.public.CONFIG_ENV === 'prod' ||
        this.$config.public.CONFIG_ENV === 'stg' ||
        this.$config.public.CONFIG_ENV === 'qa' ||
        this.$config.public.CONFIG_ENV === 'beta'
      if (path.startsWith('_nuxt/img') && isNotDevEnv) {
        path = imageCDN + path.substr('_nuxt/img'.length)
      }
      return path
    },
    // Fix focus border color issue on mobile web
    // ref: https://github.com/vuetifyjs/vuetify/issues/11942
    fixInputFocusColorIssueForMobile(form) {
      const errorColor = '#c03f45' // red50
      const observer = new MutationObserver(mutationsList => {
        mutationsList.forEach(({ type, target }) => {
          const fieldset = target.querySelector('fieldset')
          if (!fieldset) {
            return
          }

          fieldset.style = ''
          if (type === 'attributes' && target.classList.contains('v-input--has-state')) {
            const activeClass = ['success', 'error'].filter(i => target.classList.contains(`${i}--text`))[0]
            activeClass === 'error'
              ? (fieldset.style = `border-color: ${errorColor} !important;`)
              : (fieldset.style = 'border-color: #4caf50 !important;')
          }
        })
      })

      observer.observe(form, { attributes: true, subtree: true })
    },
  },
}

export default Tools
